export default "__VITE_ASSET__DjAYJHtD__"